import { Suspense } from 'react'
import Loading from '@/components/shared/Loading'
import AllRoutes from '@/components/route/AllRoutes'
import type { LayoutType } from '@/@types/theme'

interface ViewsProps {
    pageContainerType?: 'default' | 'gutterless' | 'contained'
    layout?: LayoutType
}

const Views = (props: ViewsProps) => {
    // Route chunks are lazy-loaded, so this Suspense boundary fires on every
    // in-app navigation whose chunk isn't cached yet, not just the one-time
    // post-Keycloak-login load. Keep it on the lightweight spinner -- the
    // app-wide LoadingScreen (with its 30s auto-reload) is reserved for the
    // one-time boot/login bootstrap in main.tsx and AuthProvider.
    return (
        <Suspense fallback={<Loading loading={true} className="w-full" />}>
            <AllRoutes {...props} />
        </Suspense>
    )
}

export default Views
